import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Cpu, Loader2, Info } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { StatusBadge } from "@/components/common/StatusBadge";
import { SeedBadge } from "@/components/common/SeedBadge";
import { EmptyState } from "@/components/common/EmptyState";
import { JOB_STATUS, formatDate } from "@/lib/nav";

export default function AiJobs() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/ai-jobs").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="ai-jobs-page">
      <PageHeader title="AI Jobs" subtitle="Automatisierte Verarbeitungsprozesse (Tagging, Bildoptimierung, Sync)." />

      <div className="mb-6 flex items-start gap-2 rounded-xl border border-status-warning-border bg-status-warning-bg/60 px-4 py-3">
        <Info className="mt-0.5 h-4 w-4 shrink-0 text-status-warning" />
        <p className="text-xs text-fundio-muted">Phase 1: nur Grundstruktur / Monitoring-Ansicht. Es ist <span className="font-medium text-fundio-ink">keine produktive KI angebunden</span>. Die AI-Engine wird in einer späteren Phase kontrolliert integriert.</p>
      </div>

      {items === null ? (
        <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-fundio-gold" /></div>
      ) : items.length === 0 ? (
        <EmptyState icon={Cpu} title="Keine AI-Jobs" testid="ai-jobs-empty" />
      ) : (
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {items.map((j) => (
            <div key={j.id} data-testid={`ai-job-card-${j.id}`} className="card-surface rounded-xl p-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-fundio-gold/10"><Cpu className="h-4 w-4 text-fundio-gold-deep" /></span>
                  <div><p className="text-sm font-medium text-fundio-ink">{j.label}<SeedBadge show={j.is_seed} /></p><p className="font-mono text-[10px] uppercase tracking-wider text-fundio-faint">{j.type}</p></div>
                </div>
                <StatusBadge map={JOB_STATUS} value={j.status} />
              </div>
              <div className="mt-4">
                <div className="mb-1 flex justify-between text-xs text-fundio-muted"><span>{j.brocki_name}</span><span className="font-mono">{j.progress}%</span></div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-fundio-border">
                  <div className={`h-full rounded-full ${j.status === "failed" ? "bg-status-danger" : "bg-fundio-gold"}`} style={{ width: `${j.progress}%` }} />
                </div>
                <p className="mt-2 text-[10px] text-fundio-faint">{formatDate(j.created_at)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
